export const PACE_LIST = [
  {
    label: ["14 days"],
    id: "1",
  },
  {
    label: ["28 days"],
    id: "2",
  },
  {
    label: ["90 days"],
    id: "3",
  },
  {
    label: ["180 days"],
    id: "4",
  },
];
